import React from 'react';
import PropTypes from 'prop-types';
import { InputNumber, Input } from 'antd';
import { useTheme } from '../../../contexts/ThemeContext';

const NumberInput = ({ value, onChange, type, step, precision, prefix, style, className, ...props }) => {
  const { theme, whitelabelEnabled } = useTheme();

  // Só aplicar cores customizadas se whitelabel estiver ativo
  const inputStyle = whitelabelEnabled ? {
    width: '100%',
    backgroundColor: theme.white,
    color: theme.textSecondary,
    borderColor: theme.border,
    ...style
  } : {
    width: '100%',
    ...style
  };

  if (type === 'number') {
    return (
      <InputNumber
        value={value}
        onChange={onChange}
        step={step}
        precision={precision}
        prefix={prefix}
        style={inputStyle}
        className={className}
        {...props}
      />
    );
  }

  return (
    <Input
      type={type}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      prefix={prefix}
      style={inputStyle}
      className={className}
      {...props}
    />
  );
};

NumberInput.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  type: PropTypes.string,
  step: PropTypes.number,
  precision: PropTypes.number,
  prefix: PropTypes.node,
  style: PropTypes.object,
  className: PropTypes.string,
};

export default NumberInput; 